export default {"src":"/_next/static/media/neth.7c854d0f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};